<ng-container *ngTemplateOutlet="content"></ng-container>

<div class="h-button-wrapper">
  <button axButton (click)="close()">
    {{ 'label.close' | translate }}
  </button>
</div>
